import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 32px 16px;
  background: #18181b;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 640px) {
    flex-direction: row;
  }
`

export const ActorThumbnail = styled.div`
  min-width: 288px;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  border: 3px solid #fff;
`
export const Image = styled.img`
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  flex: 1;
`
export const Name = styled.h1`
  font-size: 24px;
  color: ${Color.gray100};

  @media (min-width: 640px) {
    font-size: 28px;
  }
  @media (min-width: 768px) {
    font-size: 34px;
  }
  @media (min-width: 1028px) {
    font-size: 36px;
  }
`
export const Subtitle = styled.h4`
  font-size: 18px;
  margin-bottom: 12px;
  color: ${Color.gray300};

  @media (min-width: 768px) {
    font-size: 20px;
  }
`
export const Biography = styled.p`
  font-size: 16px;
  line-height: 25.47px;
  letter-spacing: 1.5%;
  color: ${Color.gray400};

  @media (min-width: 768px) {
    font-size: 18px;
  }
`
